import React from 'react';
import ErrorState from '../ErrorState';
import TEST_ID_PREFIX from './constants';
import { ErrorBoundaryProps, ErrorBoundaryState } from './types';

/**
 * Catches render-time errors anywhere below it and shows the full-screen error state instead of a blank page.
 */
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;

    if (!hasError) {
      return children;
    }

    return fallback ?? <ErrorState fullScreen testId={TEST_ID_PREFIX} />;
  }
}

export default ErrorBoundary;
